export default "__VITE_ASSET__8bb4406d__"